import React, { useEffect, useState } from 'react';
import {
  validateNewPassEqualConfirmPass,
  validatePassword,
  validateRequired,
} from 'utils/validate';
import FieldRegister from 'views/common/FieldRegister';
import { Button, Form, Input, Spin } from 'antd';
import Loading from 'views/common/Loading';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_STATUS } from 'constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import { cancelLogin, resetPasswordRequest } from 'store/reducers/auth';
import { useValidate, ValidateContext } from 'views/context/ValidateContext';
import TextField from 'views/common/TextField';

const ResetPassword = () => {
  const [state, setState] = useState({});
  const validate = useValidate('reset-pass');
  const { search, pathname } = useLocation();
  const { email, verifyToken } = state;
  const { status, error } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onChangeField = (e, field) => {
    setState((s) => ({ ...s, [field]: e.target.value }));
  };

  const onClickReset = () => {
    if (status === API_STATUS.PROCESSING) return;
    const error = validate.validateFields();

    if (Object.values(error || {}).length > 0) {
      return;
    }
    const { email, verifyToken, password: newPass } = state;
    dispatch(resetPasswordRequest({ email, verifyToken, newPass }));
  };

  useEffect(() => {
    if (search && pathname.includes('reset-password')) {
      const url = new URLSearchParams(search);
      const verifyToken = url.get('token');
      const email = url.get('email');

      setState({ email, verifyToken });
    } // eslint-disable-next-line
  }, [search]);

  if (status === API_STATUS.SUCCESS) {
    dispatch(cancelLogin());
    return navigate('/auth', { replace: true });
  }

  if (!email || !verifyToken) return <Loading />;

  return (
    <ValidateContext.Provider value={validate}>
      <Form onFinish={onClickReset} className="reset-password-container">
        <div className="form-container">
          <div className="form-container__header">
            <div className="title">Reset Password</div>
          </div>
          <FieldRegister
            name="passwordRegister"
            value={state.password}
            validate={[
              validateRequired('Password'),
              validatePassword,
              validateNewPassEqualConfirmPass,
            ]}
            depend={state.confirmPassword}
            onChange={(e) => onChangeField(e, 'password')}
          >
            {({ value, onChange, onBlur, error }) => (
              <TextField helperText={error}>
                <Input.Password
                  placeholder="Enter Password"
                  onChange={onChange}
                  value={value}
                  name="password-register"
                  autoComplete="section-register password"
                  maxLength={255}
                  onBlur={onBlur}
                />
              </TextField>
            )}
          </FieldRegister>

          <FieldRegister
            name="confirmPasswordRegister"
            value={state.confirmPassword}
            validate={[
              validateRequired('Confirm Password'),
              validateNewPassEqualConfirmPass,
            ]}
            depend={state.password}
            onChange={(e) => onChangeField(e, 'confirmPassword')}
          >
            {({ value, onChange, onBlur, error }) => (
              <TextField helperText={error}>
                <Input.Password
                  placeholder="Enter Confirm Password"
                  onChange={onChange}
                  value={value}
                  autoComplete="confirm-password"
                  maxLength={255}
                  name="confirm-password"
                  onBlur={onBlur}
                />
              </TextField>
            )}
          </FieldRegister>
          <div className="form-container__process">
            <div>{status === API_STATUS.PROCESSING && <Spin />}</div>
            {error && <div className="error">{error}</div>}
          </div>
          <div className="form-container__button-action">
            <Button onClick={onClickReset}>Reset</Button>
          </div>
        </div>
      </Form>
    </ValidateContext.Provider>
  );
};

export default ResetPassword;
